import { jsx as t, jsxs as v } from "@emotion/react/jsx-runtime";
import { useState as l } from "react";
import { IconButton as d } from "../../IconButton/index.js";
import { DateSelectorHeaderContainer as w, DateSelectorHeader as x } from "../DatePicker.styled.js";
import { useDatePickerContext as g } from "../DatePickerContext.js";
import { Selectors as I } from "../Selectors/Selectors.js";
import { FontAwesomeIconsPartooUsed as p } from "../../../types/components/icon.js";
import { DatePickerType as o } from "../../../types/components/dateRangePicker.js";
const L = ({
  date: r,
  changeYear: n,
  changeMonth: m,
  decreaseMonth: h,
  increaseMonth: f,
  prevMonthButtonDisabled: u,
  nextMonthButtonDisabled: k
}) => {
  const [c, M] = l(!1), [i, P] = l(!1), {
    datePickerType: e,
    localeDatePicker: C
  } = g(), a = r.getFullYear(), S = r.getMonth(), y = () => {
    e === o.MonthRangePicker || e === o.MonthSelector ? D() : f();
  }, D = () => {
    n(a + 1);
  }, Y = () => {
    e === o.MonthRangePicker || e === o.MonthSelector ? b() : h();
  }, b = () => {
    n(a - 1);
  }, s = c || i;
  return /* @__PURE__ */ t(w, { children: /* @__PURE__ */ v(x, { dropdownSelectorsOpen: s, children: [
    !s && /* @__PURE__ */ t(d, { type: "button", "aria-label": "Previous month selector", icon: [p.faChevronLeft], dataTrackId: "date-input-previous-month", onClick: Y, appearance: "outlined", disabled: u }),
    /* @__PURE__ */ t(I, { displayMonths: c, displayYears: i, setDisplayMonths: M, setDisplayYears: P, changeMonth: m, changeYear: n, date: r, locale: C.name, selectedMonth: S, selectedYear: a }),
    !s && /* @__PURE__ */ t(d, { type: "button", "aria-label": "Next month selector", icon: [p.faChevronRight], dataTrackId: "date-input-next-month", onClick: y, appearance: "outlined", disabled: k })
  ] }) });
};
export {
  L as CalendarHeader
};
